import Slide, { type SlideProps } from '@mui/material/Slide';

export const SlideTransition = (props: SlideProps) => (
  <Slide {...props} direction="up" />
);
